import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useState } from "react";
import { BetfairHistoricEvent } from "../../types/betfair/price-matching/betfair-historic-event";

interface Props {
  onEventSelected: (eventId: string) => void;
  selectedEvent: string;
  disabled: boolean;
  events: Map<number, Map<string, Map<number, BetfairHistoricEvent[]>>>;
}

export default function PriceMatchingFilters({
  onEventSelected,
  selectedEvent,
  disabled,
  events,
}: Readonly<Props>): React.JSX.Element {
  const [selectedYear, setSelectedYear] = useState<string>("");
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedDay, setSelectedDay] = useState<string>("");

  const handleYearChange = (event: SelectChangeEvent) => {
    const year = event.target.value;
    setSelectedYear(year);
    setSelectedMonth("");
    setSelectedDay("");
    onEventSelected("");
  };

  const handleMonthChange = (event: SelectChangeEvent) => {
    const month = event.target.value;
    setSelectedMonth(month);
    setSelectedDay("");
    onEventSelected("");
  };

  const handleDayChange = (event: SelectChangeEvent) => {
    const day = event.target.value;
    setSelectedDay(day);
    onEventSelected("");
  };

  const handleEventChange = (event: SelectChangeEvent) => {
    const eventId = event.target.value;
    onEventSelected(eventId);
  };

  return (
    <div className="price-matching-filters">
      Year:
      <Select
        value={selectedYear}
        onChange={handleYearChange}
        disabled={disabled}
      >
        {Array.from(events.keys() ?? []).map((year: number) => (
          <MenuItem key={year + ""} value={year + ""}>
            {year}
          </MenuItem>
        ))}
      </Select>
      Month:
      <Select
        value={selectedMonth}
        onChange={handleMonthChange}
        disabled={disabled}
      >
        {Array.from(events.get(Number(selectedYear))?.keys() ?? []).map(
          (month: string) => (
            <MenuItem key={month} value={month}>
              {month}
            </MenuItem>
          )
        )}
      </Select>
      Day:
      <Select
        value={selectedDay}
        onChange={handleDayChange}
        disabled={disabled}
      >
        {Array.from(
          events.get(Number(selectedYear))?.get(selectedMonth)?.keys() ?? []
        ).map((day) => (
          <MenuItem key={day + ""} value={"" + day}>
            {day}
          </MenuItem>
        ))}
      </Select>
      Event:
      <Select
        value={selectedEvent}
        onChange={handleEventChange}
        disabled={disabled}
      >
        {events
          .get(Number(selectedYear))
          ?.get(selectedMonth)
          ?.get(Number(selectedDay))
          ?.map((event: BetfairHistoricEvent) => (
            <MenuItem
              key={event.betfairHistoricEventId}
              value={event.betfairEventId}
            >
              {event.team1Name} vs {event.team2Name} {event.year}/{event.month}/
              {event.day}
            </MenuItem>
          ))}
      </Select>
    </div>
  );
}
